/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Bид для элемента паджинации в корзине.
   */
  app.CartPaginationView = app.PaginationView.extend({
    _needClear: function (pageCount) {
      return pageCount < 2 || this.router.mode === 'infinite';
    },
    show: function () {
      this.$el.show();
    },
    
    hide: function () {
      this.$el.hide();
    }
  });
})();

}.call(window));